<template>
  <v-container grid-list-xl>
    <v-form v-model="isAddValid">
      <v-layout row wrap>
        <center style="width: 100%"><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" v-if="departmentLoader == true" /></center>
        <v-tabs slider-color="grey" v-if="departmentLoader == false">
          <v-tab class="tab" :key="1" ripple>Details</v-tab>
         <!-- <v-tab class="tab" :key="2" ripple>Process Calculator</v-tab>
          <v-tab class="tab" :key="3" ripple>Process Product Codes</v-tab>-->
          <v-tab class="tab" :key="2" ripple>Form Messaging</v-tab>
          <v-tab class="tab" :key="3" ripple>Tabs</v-tab>
          <v-tab class="tab" :key="4" ripple>Form</v-tab>
          <v-tab class="tab" :key="5" ripple>Calculator Links</v-tab>
          <v-tab class="tab" :key="6" ripple>Starting Rules</v-tab>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg4>
                  <label class="blackLabel">Name:</label>
                  <v-text-field label="Name" v-model="processName" single-line required :rules="nameRules" solo></v-text-field>
                  <small class="smallDescription">Name of the service form</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Department:</label>
                  <v-select :items="departmentList" label="Process Department" item-value="id" item-text="name" v-model="processDepartment" required :rules="departmentRules" autocomplete single-line solo></v-select>
                  <small class="smallDescription">Department the service form belongs to</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Process Token:</label>
                  <v-text-field label="Token" v-model="processToken" single-line required solo></v-text-field>
                  <small class="smallDescription">Token linked to the service form</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Onsite Visit Article Ticket Name:</label>
                  <v-text-field label="Onsite Visit Article Name" v-model="processHsArticleName" single-line solo></v-text-field>
                  <small class="smallDescription">The onsite visit article ticket name</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Onsite Visit Article Ticket Number:</label>
                  <v-text-field label="Onsite Visit Article Number" v-model="processHsArticleNumber" single-line solo></v-text-field>
                  <small class="smallDescription">The onsite visit article ticket number</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Onsite Visit Article Ticket Price:</label>
                  <v-text-field label="Onsite Visit Article Price" v-model="processHsArticlePrice" single-line solo></v-text-field>
                  <small class="smallDescription">The onsite visit article ticket price</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Process Roles To Display:</label>
                  <v-select :items="userRoles" v-model="processRoles" item-value="id" item-text="name" label="Process User Roles" autocomplete multiple solo></v-select>
                  <small class="smallDescription">Show user roles that should be linked to this service form quotes</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Checkout Branch:</label>
                  <v-select :items="branchList" v-model="checkoutBranch" item-value="code" item-text="name" label="Checkout Branch" autocomplete solo></v-select>
                  <small class="smallDescription">Select if checkout is for specific branch</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Waiver Callout Fee For Commercial Clients:</label>
                  <v-switch label="Waiver fee for commercial clients" v-model="overrideCallout"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg4>
                  <label class="blackLabel">Contact Customer Message:</label>
                  <v-text-field label="Contact Me Message" v-model="popupContact" multi-line required solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Request Quote Message:</label>
                  <v-text-field label="Quote Request Message" v-model="popupRequest" multi-line required solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Request Measure to Quote Message:</label>
                  <v-text-field label="Onsite Visit Message" v-model="popupVisit" multi-line required solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Request Measure to Quote Message - Payment Required:</label>
                  <v-text-field label="Request Measure to Quote - Payment Required" v-model="popupPayment" multi-line required solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Calculator Message:</label>
                  <v-text-field label="Calculator Message" v-model="popupCalculator" multi-line required solo></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <!--<v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg12>
                  <label class="blackLabel">Process Ranges:</label>
                  <v-select :items="departmentRangesList" v-model="processRanges" item-value="id32" item-text="name" label="Department Ranges" autocomplete solo></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg3 v-for="(product_code, index) in processCodes">
                  <v-text-field label="Product Code" v-model="processCodes[index].value" single-line solo></v-text-field>
                  <a @click="fncRemoveProcessRange(index)" class="departmentRangeRemove">Remove</a>
                </v-flex>
                <v-flex lg3>
                  <v-btn color="success" class="text-xs-right" @click.stop="fncAddProductCode()">Save Product Code</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>-->
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg12>
                  <p>Setup the dynamic tabs that will be displayed in your Service Form.</p>
                </v-flex>
                <v-flex lg4 v-if="showAdd == true">
                  <label class="blackLabel">Tab Name:</label>
                  <v-text-field label="Tab Name" v-model="tabName" single-line required solo></v-text-field>
                </v-flex>
                <!--<v-flex lg4 v-if="showAdd == true">
                  <label class="blackLabel">Tab For:</label>
                  <v-select :items="tabForValues" label="Select the type of tab" item-value="id" item-text="text" v-model="tabFor" required autocomplete multiple solo></v-select>
                </v-flex>-->
                <v-flex lg4 v-if="showAdd == true">
                  <label class="blackLabel">Show Client:</label>
                  <v-switch label="Show tab to client" v-model="tabClient"></v-switch>
                </v-flex>
                <v-flex lg4 v-if="showAdd == true">
                  <label class="blackLabel">Show For Which Service Types:</label>
                  <v-select :items="tabForValues" label="Select the service types that apply to this tab" item-value="id" item-text="text" v-model="tabFor" required autocomplete multiple solo></v-select>
                </v-flex>
                <v-flex v-if="showAdd == true" lg11>&nbsp;</v-flex>
                <v-flex v-if="showAdd == true" lg1><v-btn color="success" class="text-xs-right" style="right:30px;" @click.stop="fncAddTab()">Save Tab</v-btn></v-flex>

                <v-flex lg4 v-if="showEdit == true">
                  <label class="blackLabel">Tab Name:</label>
                  <v-text-field label="Tab Name" v-model="editTabName" single-line required solo></v-text-field>
                </v-flex>
                <v-flex lg4 v-if="showEdit == true">
                  <label class="blackLabel">Show For Which Service Types:</label>
                  <v-select :items="tabForValues" label="Select the type of tab" item-value="id" item-text="text" v-model="editTabFor" required autocomplete multiple solo></v-select>
                </v-flex>
                <v-flex lg4 v-if="showEdit == true">
                  <label class="blackLabel">Show Client:</label>
                  <v-switch label="Show tab to client" v-model="editTabClient"></v-switch>
                </v-flex>
                <v-flex v-if="showEdit == true" lg11>&nbsp;</v-flex>
                <v-flex v-if="showEdit == true" lg1><v-btn color="success" class="text-xs-right" style="right:30px;" @click.stop="fncUpdateTab()">Update Tab</v-btn></v-flex>

                <v-flex style="margin-top: -30px;" v-if="showAdd == false && showEdit == false" lg11>&nbsp;</v-flex>
                <v-flex style="margin-top: -30px;" v-if="showAdd == false && showEdit == false" lg1><v-btn color="success" class="text-xs-right" style="right:17px;" @click.stop="fncShowAdd()">Create Tab</v-btn></v-flex>
                <v-data-table v-if="showAdd == false && showEdit == false" loading="true" :headers="tabHeaders" :items="processTabs" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1 processTabs">
                  <template slot="items" slot-scope="props">
                    <tr class="sortableRow" id="rows">
                      <td width="5%" class="px-1">
                        <v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn>
                      </td>
                      <td width="40%">{{ props.item.name }}</td>
                      <td width="35%" class="text-xs-right">{{ fncGetYesNo(props.item.is_client) }}</td>
                      <td width="10%" class="text-xs-right"><a @click.prevent="fncShowEdit( props.item.id )"><i class="material-icons">edit</i></a></td>
                      <td width="10%" class="text-xs-right"><a @click.prevent="fncDeleteTab( props.item.id )"><i class="material-icons">delete</i></a></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg12>
                  <p>Setup the dynamic form fields for the dynamic tabs that will be displayed in your Service Form.</p>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Select Tab:</label>
                  <v-select :items="processTabs" label="Select the tab you want to add form fields to" item-value="id" item-text="name" v-model="currentFormTab" required autocomplete single-line solo></v-select>
                </v-flex>
                <v-flex lg5>
                  <label class="blackLabel">Select Input Type:</label>
                  <v-select :items="columnType" label="Select input type" item-value="id" item-text="text" v-model="currentFormColumn" required autocomplete single-line solo></v-select>
                </v-flex>
                <v-flex lg1>
                  <label class="blackLabel">&nbsp;</label>
                  <v-btn color="success" class="text-xs-right" @click.stop="fncAddColumn()">Add</v-btn>
                </v-flex>
                <v-flex lg12 v-for="(tabInfo, index) in this.processTabForms[this.currentFormTab]">
                  <!--0 { "label": "", "required": false, "type": "input" }-->
                  <div style="background: #EFEFEF;float: left; clear: both;width: 100%;padding-bottom: 16px;" v-if="tabInfo.type == 'input'" >
                    <div style="padding-left: 20px;width: 48.5%;float: left; padding-top: 20px;">
                      <p>Input Label:</p>
                      <v-text-field label="Input Label" @input="fncResetState()" style="width:90%" v-model="processTabForms[currentFormTab][index].label" single-line required solo></v-text-field>
                    </div>
                    <div style="width: 48.5%;float: left; padding-top: 20px;">
                      <p>Required:</p>
                      <v-switch @change="fncResetState()" label="Is the input a required field" v-model="processTabForms[currentFormTab][index].required"></v-switch>
                    </div>
                    <div style="width: 3%;float: left; padding-top: 12px;">
                      <a @click.prevent="fncDeleteFormItem(index)"><i class="material-icons">delete</i></a>
                    </div>
                  </div>
                  <div style="background: #EFEFEF;float: left; clear: both;width: 100%;padding-bottom: 16px;" v-if="tabInfo.type == 'select'" >
                    <div style="padding-left: 20px;width: 32.33%;float: left; padding-top: 20px;">
                      <p>Input Label:</p>
                      <v-text-field @input="fncResetState()" label="Input Label" style="width:90%" v-model="processTabForms[currentFormTab][index].label" single-line required solo></v-text-field>
                    </div>
                    <div style="padding-left: 20px;width: 32.33%;float: left; padding-top: 20px;">
                      <p>Dropdown Values:</p>
                      <v-text-field @input="fncResetState()" label="Dropdown Values" style="width:90%" v-model="processTabForms[currentFormTab][index].values" single-line required solo></v-text-field>
                    </div>
                    <div style="width: 32.33%;float: left; padding-top: 20px;">
                      <p>Required:</p>
                      <v-switch @change="fncResetState()" label="Is the input a required field" v-model="processTabForms[currentFormTab][index].required"></v-switch>
                    </div>
                    <div style="width: 3%;float: left; padding-top: 12px;">
                      <a @click.prevent="fncDeleteFormItem(index)"><i class="material-icons">delete</i></a>
                    </div>
                  </div>
                  <div style="background: #EFEFEF;float: left; clear: both;width: 100%;padding-bottom: 16px;" v-if="tabInfo.type == 'yesno'" >
                    <div style="padding-left: 20px;width: 48.5%;float: left; padding-top: 20px;">
                      <p>Input Label:</p>
                      <v-text-field @input="fncResetState()" label="Input Label" style="width:90%" v-model="processTabForms[currentFormTab][index].label" single-line required solo></v-text-field>
                    </div>
                    <div style="width: 48.5%;float: left; padding-top: 20px;">
                      <p>Required:</p>
                      <v-switch @change="fncResetState()" label="Is the input a required field" v-model="processTabForms[currentFormTab][index].required"></v-switch>
                    </div>
                    <div style="width: 3%;float: left; padding-top: 12px;">
                      <a @click.prevent="fncDeleteFormItem(index)"><i class="material-icons">delete</i></a>
                    </div>
                  </div>
                  <div style="background: #EFEFEF;float: left; clear: both;width: 100%;padding-bottom: 16px;" v-if="tabInfo.type == 'header'" >
                    <div style="padding-left: 20px;width: 97%;float: left; padding-top: 20px;">
                      <p>Header Title:</p>
                      <v-text-field @input="fncResetState()" placeholder="Header Label" style="width:90%" v-model="processTabForms[currentFormTab][index].label" single-line required solo></v-text-field>
                    </div>
                    <div style="width: 3%;float: left; padding-top: 12px;">
                      <a @click.prevent="fncDeleteFormItem(index)"><i class="material-icons">delete</i></a>
                    </div>
                  </div>
                  <div style="background: #EFEFEF;float: left; clear: both;width: 100%;padding-bottom: 16px;" v-if="tabInfo.type == 'break'" >
                    <div style="padding-left: 20px;width: 97%;float: left; padding-top: 20px;">
                      <h3>BREAK</h3>
                    </div>
                    <div style="width: 3%;float: left; padding-top: 12px;">
                      <a @click.prevent="fncDeleteFormItem(index)"><i class="material-icons">delete</i></a>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="5">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-data-table style="margin-top: 0px;" :headers="calcHeaders" :items="calculatorLinks" hide-actions class="elevation-1 repLinkTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                  <template slot="items" slot-scope="props">
                    <td width="40%"><v-text-field label="Calculator Name" v-model="props.item.name" single-line solo></v-text-field></td>
                    <td width="50%"><v-text-field label="Calculator Link" v-model="props.item.link" single-line solo></v-text-field></td>
                    <td width="10%"><v-btn class="text-xs-right" style="margin-top: 2% !important;float: right;background: #333;color: #fff;margin-right: 1.5% !important;" @click.stop="fncDeleteRow( props )">Delete Row</v-btn></td>
                  </template>
                </v-data-table>
                <v-btn class="text-xs-right" style="margin-top: 2% !important;float: right;background: #333;color: #fff;margin-right: 1.5% !important;" @click.stop="fncAddRow()">Add Calculator Row</v-btn>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="6">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg12>
                  Customer Service Form
                </v-flex>
                <v-flex lg12>
                  <v-select :items="serviceType" label="Service Type" item-value="id" item-text="name" v-model="startingRulesCustomer" autocomplete multiple solo></v-select>
                </v-flex>
                <v-flex lg12>
                  Selected Roles Service Form
                </v-flex>
                <v-flex lg6>
                  <v-select :items="userRoles" label="Roles" item-value="id" item-text="name" v-model="startingRulesRoles" autocomplete multiple solo></v-select>
                </v-flex>
                <v-flex lg6>
                  <v-select :items="serviceType" label="Service Type" item-value="id" item-text="name" v-model="startingRulesSet" autocomplete multiple solo></v-select>
                </v-flex>
                <v-flex lg12>
                  Other Service Form ( This will apply for circumstances not covered by the above )
                </v-flex>
                <v-flex lg12>
                  <v-select :items="serviceType" label="Service Type" item-value="id" item-text="name" v-model="startingRulesOther" autocomplete multiple solo></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <div class="pl-4 pr-1 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-btn color="success" class="text-xs-right" :disabled="!isAddValid" @click.stop="fncAddProcess()">Save</v-btn>
            <small>* The button will activate once all required fields have been completed.</small>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Sortable from 'sortablejs';

  export default {
    name: 'RegionAdd',
    data () {
      return {
        search: '',
        currentFormTab: 0,
        currentFormColumn: '',
        isAddValid: false,
        showAdd: false,
        showEdit: false,
        editTabId: 0,
        editTabName: '',
        editTabClient: false,
        editTabFor: [],
        processName: '',
        processToken: '',
        processDepartment: 0,
        processTabs: [],
        tabName: '',
        tabClient: false,
        tabFor: [],
        popupPayment: '',
        popupContact: '',
        popupRequest: '',
        popupVisit: '',
        popupCalculator: '',
        tabHeaders: [
          { text: '', value: 'name', width: '5%' },
          { text: 'Name', value: 'name', width: '40%' },
          { text: 'Show Client', value: 'description', width: '35%' },
          { text: 'Edit', value: 'created_on', width: '10%' },
          { text: 'Delete', value: 'edit', width: '106%' },
        ],
        columnType: [
          { id: 'header', text: 'HEADER LABEL - adds a header' },
          { id: 'input', text: 'INPUT FIELD - adds a text field' },
          { id: 'select', text: 'SELECT / DROPDOWN - adds a choice dropdown' },
          { id: 'yesno', text: 'YES / NO TRIGGER - adds a radio button for yes / no selection' },
          { id: 'break', text: 'BREAK - adds a linebreak' }
        ],
        calcHeaders: [
          { text: 'Name', value: 'name', width: '40%' },
          { text: 'Link', value: 'description', width: '50%' },
          { text: 'Delete', value: 'edit', width: '10%' }
        ],
        tabForValues: [
          { id: '1', text: 'Contact Me' },
          { id: '2', text: 'Quote Request' },
          { id: '3', text: 'Onsite Visit' }
        ],
        nameRules: [
          v => !!v || 'Process name is required'
        ],
        departmentRules: [
          v => !!v || 'Process Department is required'
        ],
        processRanges: 0,
        processCodes: [{ value: '' }],
        processTabForms: {},
        processHsArticleName: '',
        processHsArticleNumber: '',
        processHsArticlePrice: '',
        processRoles: '',
        checkoutBranch: '',
        overrideCallout: false,
        calculatorLinks: [{ name: '', link: '' }],
        startingRulesCustomer: [],
        startingRulesRoles: [],
        startingRulesSet: [],
        startingRulesOther: [],
        serviceType: [
          { id: 1, name: 'Contact Customer' },
          { id: 2, name: 'Request Quote' },
          { id: 3, name: 'Request Measure To Quote' },
          { id: 5, name: 'Request Calculator' }
        ]
      };
    },
    methods: {
      fncDeleteRow( props ) {
        this.calculatorLinks.splice(props.index,1);
      },
      fncAddRow() {
        this.calculatorLinks.push({ name: '', link: '' });
      },
      fncDeleteFormItem(index) {
        var confirmDelete = confirm("Are you sure you want to delete this form item?");
        if (confirmDelete == true) {
          var newFormFields = [];
          for( var i in this.processTabForms[this.currentFormTab] ) {
            if( i != index ) {
              newFormFields.push( this.processTabForms[this.currentFormTab][i] );
            }
          }
          this.processTabForms[this.currentFormTab] = newFormFields;
          var toSet = this.currentFormTab;
          this.fncResetState();
        }
      },
      fncResetState() {
        this.currentFormColumn = '9';
        this.currentFormColumn = '';
      },
      fncAddColumn() {
        var selectedTab = this.currentFormTab;
        if( selectedTab != undefined && selectedTab != '' && selectedTab != '0' ) {
          if( this.processTabForms[selectedTab] == undefined || this.processTabForms[selectedTab] == null ) {
            this.processTabForms[selectedTab] = [];
          }
          if( this.currentFormColumn == 'input' ) {
            this.processTabForms[selectedTab].push({ label: '', required: false, type: 'input', value: '' });
          } else if( this.currentFormColumn == 'select' ) {
            this.processTabForms[selectedTab].push({ label: '', required: false, values: '', type: 'select', value: '' });
          } else if( this.currentFormColumn == 'yesno' ) {
            this.processTabForms[selectedTab].push({ label: '', required: false, type: 'yesno', value: '' });
          } else if( this.currentFormColumn == 'header' ) {
            this.processTabForms[selectedTab].push({ label: '', required: false, type: 'header', value: '' });
          } else if( this.currentFormColumn == 'break' ) {
            this.processTabForms[selectedTab].push({ type: 'break' });
          }
          this.currentFormColumn = '';
        }
      },
      fncRemoveProcessRange( index ) {
        var newProductCodes = [];
        for( var i in this.processCodes ) {
          if( i != index ) {
            newProductCodes.push(this.processCodes[i]);
          }
        }
        if( newProductCodes.length == 0 ) {
          newProductCodes = [{ value: '' }];
        }
        this.processCodes = newProductCodes;
      },
      fncAddProductCode() {
        this.processCodes.push({ value: '' });
      },
      fncGetYesNo( check ) {
        if( check == 'true' || check == true ) {
          return 'Yes';
        } else {
          return 'No';
        }
      },
      fncUpdateTab() {
        for( var t in this.processTabs ) {
          if( this.processTabs[t].id == this.editTabId ) {
            this.processTabs[t].name = this.editTabName;
            this.processTabs[t].is_client = this.editTabClient;
            this.processTabs[t].tab_for = this.editTabFor;
            this.editTabId = 0;
          }
        }
        this.showEdit = false;
      },
      fncShowEdit( tabId ) {
        this.showEdit = true;
        this.showAdd = false;
        for( var t in this.processTabs ) {
          if( this.processTabs[t].id == tabId ) {
            this.editTabName = this.processTabs[t].name;
            this.editTabClient = this.processTabs[t].is_client;
            this.editTabFor = this.processTabs[t].tab_for;
            this.editTabId = this.processTabs[t].id;
          }
        }
      },
      fncDeleteTab( tabId ) {
        var confirmDelete = confirm("Are you sure you want to delete this tab?");
        if (confirmDelete == true) {
          var newTabs = [];
          var newFormTabs = [];
          for( var f in this.processTabForms ) {
            if( f != tabId ) {
              newFormTabs.push( this.processTabForms[f] );
            }
          }
          this.processTabForms = newFormTabs;
          for (var t in this.processTabs) {
            if (this.processTabs[t].id != tabId) {
              newTabs.push(this.processTabs[t]);
            }
          }
          this.processTabs = newTabs;
        }
      },
      fncAddTab() {
        var randId = Math.floor((Math.random() * 100000) + 1);
        this.processTabs.push({ id: randId, name: this.tabName, is_client: this.tabClient, tab_for: this.tabFor, form: []});
        this.tabName = '';
        this.tabClient = false;
        this.tabFor = [];
        this.showAdd = false;
      },
      fncShowAdd() {
        this.showAdd = true;
      },
      fncHideModal () {
        this.$store.commit('hideModal');
      },
      fncAddProcess() {
        var startingRules = { 'customer': this.startingRulesCustomer, 'other': this.startingRulesOther, roles: this.startingRulesRoles, rolesRules: this.startingRulesSet }

        this.$store.dispatch({
          type: 'fncProcessAdd',
          processName: this.processName,
          processToken: this.processToken,
          processDepartment: this.processDepartment,
          processTabs: this.processTabs,
          processRanges: this.processRanges,
          processCodes: this.processCodes,
          processTabForms: this.processTabForms,
          processHsArticleName: this.processHsArticleName,
          processHsArticleNumber: this.processHsArticleNumber,
          processHsArticlePrice: this.processHsArticlePrice,
          processRoles: this.processRoles,
          checkoutBranch: this.checkoutBranch,
          overrideCallout: this.overrideCallout,
          popupPayment: this.popupPayment,
          popupContact: this.popupContact,
          popupRequest: this.popupRequest,
          popupVisit: this.popupVisit,
          popupCalculator: this.popupCalculator,
          calculatorLinks: this.calculatorLinks,
          startingRules: startingRules
        });
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'departmentList',
        'departmentLoader',
        'departmentRangesList',
        'userRoles',
        'branchList'
      ])
    },
    mounted(){
      this.$store.dispatch('fncPopulateDepartments');

      if( this.$refs.sortableTable != undefined ) {
        new Sortable(
          this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
          {
            draggable: '.sortableRow',
            handle: '.sortHandle',
            dragoverBubble: false,
            // onUpdate: this.fncReorderQuoteColumns,
            removeCloneOnHide: false
          }
        )
      }
    },
    beforeMount() {
      this.$store.dispatch('fncPopulateRoles');
      this.$store.dispatch('fncPopulateBranches');
    },
    watch: {
      runAdd() {
        if( this.runAdd === false ) {
          this.isAddValid = false;
          this.regionLink = '';
          this.regionName = '';
          this.regionDescription = '';
          this.regionType = '';
        }
      }
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
